import axios from "../../../utils/authAxios";
const api_base_url = process.env.REACT_APP_API_BASEURL;

export const getEmployeeTitle = async () => {
  const data = await axios.get(
    `${api_base_url}/EmployeeConfiguration/EmployeeTitle`
  );
  return data;
};

export const getEmployeeTitleFilter = async () => {
  const data = await axios.get(
    `${api_base_url}/EmployeeConfiguration/EmployeeTitleFilter`
  );
  return data;
};

export const addEmployeeTitle = async (newEmployeeTitle) => {
  return axios.post(`${api_base_url}/EmployeeConfiguration/EmployeeTitle`, {
    ...newEmployeeTitle,
  });
};

export const deleteEmployeeTitle = async (ids) => {
  await axios.delete(`${api_base_url}/EmployeeConfiguration/EmployeeTitle`, {
    data: ids,
  });
};

export const updateEmployeeTitle = async (editEmployeeTitle) => {
  const formData = new FormData();
  editEmployeeTitle.employeeTitleId &&
    formData.append("employeeTitleId", editEmployeeTitle.employeeTitleId);
  editEmployeeTitle.employeeTitleName &&
    formData.append("employeeTitleName", editEmployeeTitle.employeeTitleName);
  editEmployeeTitle.jobCode &&
    formData.append("jobCode", editEmployeeTitle.jobCode);
  editEmployeeTitle.jobLong &&
    formData.append("jobLong", editEmployeeTitle.jobLong);
  editEmployeeTitle.createdBy &&
    formData.append("createdBy", editEmployeeTitle.createdBy);
  editEmployeeTitle.createdDate &&
    formData.append("createdDate", editEmployeeTitle.createdDate);
  editEmployeeTitle.isActive !== null &&
    formData.append("isActive", editEmployeeTitle.isActive);
  editEmployeeTitle.usedInMexico !== null &&
    formData.append("usedInMexico", editEmployeeTitle.usedInMexico);
  return axios.put(
    `${api_base_url}/EmployeeConfiguration/${editEmployeeTitle.employeeTitleId}`,
    formData
  );
};
